import Vue from 'vue';
import Router from 'vue-router';
import ActivationRequest from '@/components/ActivationRequest';
import ActivationResponse from '@/components/ActivationResponse';
import ActivationCode from '@/components/ActivationCode';
import ActivationTimeout from '@/components/ActivationTimeout';
import ActivationError from '@/components/ActivationError';

Vue.use(Router);

const router = new Router({
    //mode: 'history', // uris without hashes #, see https://router.vuejs.org/guide/essentials/history-mode.html#html5-history-mode
    //base: ROUTE_BASE_URL,
    routes: [
        { path: '/', redirect: '/activation-request' },
        { path: '/activation-request', name: 'ActivationRequest', component: ActivationRequest, props: true },
        { path: '/response', name: 'ActivationResponse', component: ActivationResponse },
        { path: '/success', name: 'ActivationCode', component: ActivationCode, props: true },
        { path: '/timeout', name: 'ActivationTimeout', component: ActivationTimeout },
        { path: '/error', name: 'ActivationError', component: ActivationError },
        { path: '*', redirect: '/error' }
    ]
});

export default router;